// extracted by mini-css-extract-plugin
export default {"loaderOverlay":"Loader_loaderOverlay__YY3QH","loaderCenterFix":"Loader_loaderCenterFix__0-mQy","loader":"Loader_loader__pvYRd","animloader":"Loader_animloader__WIbbN"};